import React, { useState, useEffect, Button, Platform, Alert } from 'react';
// eslint-disable-next-line 
import { useParams, Link, Route, Routes, } from 'react-router-dom'
import axios from "axios";



import { firebase } from "../Firebase/config";
// eslint-disable-next-line 
import { doc, getDoc, updateDoc, arrayUnion, } from "@firebase/firestore";
import NavBar from "./Navbar"

import './Messages.css';


function App(hello, studentidd) { // eslint-disable-line no-unused-vars

  // eslint-disable-next-line 
  const { only2studentid, studentid, classid, language, id } = useParams();



//with teacher access

//   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

//   http://localhost:3000/view/id/VO9zbrZ6czMhZTqwGkfBBEjH2CD2/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en

//without teacher access

 //   http://localhost:3000/studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en 

  //   http://localhost:3000/only2studentid/kK8E2a6D8ehgGV3tXk22vkMFV3Z2/classid/qBQ5dp9aCn5cP8EcoTur/language/en 
 


  const [studentidlocal, setstudentidlocal] = useState();



  const [parentemail, setParentemail] = useState();
  const [parentemailbefore, setParentemailbefore] = useState();
  // eslint-disable-next-line 
  const [newnumber2, setNewnumber2] = useState("");

  const [newnumber3, setNewnumber3] = useState();

  const [parentphonenumber, setParentphonenumber] = useState();
  const [parentphonenumberbefore, setParentphonenumberbefore] = useState();
  // eslint-disable-next-line 
  const [newnumber, setNewnumber] = useState("");

  const [teacher, setTeacher] = useState();
  const [classs, setClasss] = useState();
  const [student, setStudent] = useState();
  const [viewparentpage, setViewparentpage] = useState(true);

  const [text0, setText0] = useState("");
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");
  const [text6, setText6] = useState("");
  const [text7, setText7] = useState("");
  const [text8, setText8] = useState("");


  // Donotshow is used to show the toggle icon that is only worth showing to teachers on the About page. So it is true everywhere but on about page. 
  const [donotshow, setDonotshow] = useState();

  const [videoFile, setVideoFile] = useState(null);


  const handleVideoChange = (e) => {
    setVideoFile(e.target.files[0]);
  };



  const handleUpload = async () => {

    // if (process.env.NODE_ENV == 'development') {

    //   handleUploadA();
    // } else {
    //   handleUploadB();
    // }

}


  // const handleUploadA = async () => {
  //   if (!videoFile) return;

  //   const formData = new FormData();
  //   formData.append('video', videoFile);

  //   try {
  //     const response = await axios.post('http://localhost:3002/api/upload2', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //       }
  //     });

  //     // Handle response, e.g., download compressed video
  //     alert('Upload success:' + response.data);
  //   } catch (error) {
  //     alert('Upload error:' + error);
  //   }
  // };

  // const handleUploadB = async () => {

   
  //   if (!videoFile) return;

  //   const formData = new FormData();
  //   formData.append('video', videoFile);

  //   try {
  //     const response = await axios.post('https://sleepy-falls-78216-6abb1d3b0d95.herokuapp.com/api/upload2', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //       }
  //     });

  //     // Handle response, e.g., download compressed video
     
  //     alert('File compressed successfully');
  //   } catch (error) {
  //    alert('Upload error:'+ error);
  //   }
  // };





console.log(language, "THI SIS IS THE LANGUSAST")

  useEffect(() => {
    if (
      typeof language != "undefined" && language != "en"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
    }
  }, [language]);

  useEffect(() => {
    if (
      typeof language != "undefined" && language != "en"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
    }
  }, []);

  useEffect(() => {
    if (
      typeof language != "undefined" && language != "en"
    ) {
      getnewlanguaage0();
      getnewlanguaage1();
      getnewlanguaage2();
      getnewlanguaage3();
      getnewlanguaage4();
      getnewlanguaage5();
      getnewlanguaage6();
      getnewlanguaage7();
      getnewlanguaage8();
    }
  }, [language]);


  useEffect(() => {
 
    setDonotshow(true);
      
    }, []);



    const getnewlanguaage0 = async () => {
      console.log(language, "2 the languge code");
  
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "Messaging From",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText0(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      
    };
  
    const getnewlanguaage1 = async () => {
      console.log(language, "2 the languge code");
  
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "Class",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText1(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      
    };
  
    const getnewlanguaage2 = async () => {
      console.log(language, "2 the languge code");
  
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "The emails and phone numbers that",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText2(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      
    };
  
    const getnewlanguaage3 = async () => {
      console.log(language, "2 the languge code");
  
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "has to message you are listed below. Please leave only the numbers or email addresses if it is there where you would like to receive messages.",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText3(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
    };
  
    const getnewlanguaage4 = async () => {
      console.log(language, "2 the languge code");
  
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "Please delete the rest by pressing",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText4(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
    };
  
    const getnewlanguaage5 = async () => {
      console.log(language, "2 the languge code");
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "Add any additional phone number or email address if it is there where you would also like to receive messages.",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText5(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
      
    };
  
    const getnewlanguaage6 = async () => {
      console.log(language, "2 the languge code");
        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "Submit this Phone Number",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText6(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
    };
  
    const getnewlanguaage7 = async () => {
      console.log(language, "2 the languge code");

        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "Submit this new Email",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText7(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
    };
  
    const getnewlanguaage8 = async () => {
      console.log(language, "2 the languge code");

        try {
          const response = await axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyC864hxQIdWZobAgG0RkMwhMNuxoWRYEPY`,
            {
              source: "en",
              format: "text",
              q: "New Email/Phone #",
              target: language,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          setText8(response.data.data.translations[0].translatedText);
        } catch (error) {
          console.error("Error:", error);
        }
    };
  


  
  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
    }

    if (typeof studentid != "undefined") {
      let teach = localStorage.getItem("nameofteacher");
      let clas = localStorage.getItem("nameofclass");
      let stud = localStorage.getItem("nameofstudent");

      setTeacher(teach);
      setClasss(clas);
      setStudent(stud);
    }
  }, [only2studentid, studentid]);



  useEffect(() => {
    if (typeof only2studentid != "undefined") {
      setstudentidlocal(only2studentid)
    }
  }, [only2studentid]);

  useEffect(() => {
    if (typeof studentid != "undefined") {
      setstudentidlocal(studentid)
    }
  }, [studentid]);
  useEffect(() => {
    if (typeof studentidlocal != "undefined" && studentidlocal.length > 10) {
      seeifpersonexists();
    }
  }, [studentidlocal]);

  async function seeifpersonexists() {
    const docRef = doc(firebase, "users", studentidlocal);

    const docData = await getDoc(docRef)

      .then(async (userRec) => {

        let object = userRec.data();
        setParentemail(object.parentemail);
        setParentphonenumber(object.parentphonenumber);

        console.log(object, "it found this guy?")
      }).catch((error) => {
        // Handle any errors that occur

      }).then(async () => {

        console.log("ending rightnow")
      })
  }

  useEffect(() => {
    if (typeof studentidlocal != "undefined" && typeof parentphonenumber != "undefined") {
      console.log("in the final area")
      updatephonenumbberindatabase();
    }
  }, [parentphonenumber]);

  const onChanged1 = (text) => {
    setNewnumber3(text);
  }

  useEffect(() => {
    if (typeof parentphonenumberbefore != "undefined") {
      console.log(parentphonenumberbefore, "y999");

      // let array = parentphonenumber;
      // array.push(parentphonenumberbefore)
 const safeParentPhoneNumber = Array.isArray(parentphonenumberbefore)
      ? parentphonenumberbefore
      : [parentphonenumberbefore];

      updateDoc(doc(firebase, "users", studentidlocal), {
        parentphonenumber: safeParentPhoneNumber
      }).catch((error) => {
        console.log(error); alert(error);
      })
    }
  }, [parentphonenumberbefore]);

  useEffect(() => {
    if (typeof parentemailbefore != "undefined") {
      console.log(parentemailbefore, "y999");

      // let array = parentphonenumber;
      // array.push(parentphonenumberbefore)

 const safeParentEmail = Array.isArray(parentemailbefore)
      ? parentemailbefore
      : [parentemailbefore];

      updateDoc(doc(firebase, "users", studentidlocal), {
        parentemail: safeParentEmail
      }).catch((error) => {
        console.log(error); alert(error);
      })
    }
  }, [parentemailbefore]);


  async function addthisnumber() {

    console.log("add a new nummber was runnd", parentphonenumber);

    let currenntarray = parentphonenumber;

    currenntarray.push(newnumber3);
    setParentphonenumber(currenntarray);
    setParentphonenumberbefore(currenntarray);
    setNewnumber3("");
  }

  async function addthisnumber2() {

    console.log("add a new nummber was runnd", parentemail);

    let currenntarray2 = parentemail;

    currenntarray2.push(newnumber3);

    setParentemail(currenntarray2);
    setParentemailbefore(currenntarray2);
    setNewnumber3("");
  }


  async function updatephonenumbberindatabase() {

    console.log("did it get  in to update?", parentphonenumber)

     const safeParentPhoneNumber = Array.isArray(parentphonenumber)
      ? parentphonenumber
      : [parentphonenumber];

    await updateDoc(doc(firebase, "users", studentidlocal), {
      parentphonenumber: safeParentPhoneNumber
    }).catch((error) => {
      console.log(error); alert(error);
    })
      .then(async (userRec) => {
        console.log("DOnneee")
        setParentphonenumberbefore();
      })

  }

  async function updateemailindatabase() {

    console.log("did it get  in to update?", parentemail)

     const safeParentEmail = Array.isArray(parentemail)
      ? parentemail
      : [parentemail];


    await updateDoc(doc(firebase, "users", studentidlocal), {
      parentemail: safeParentEmail
    }).catch((error) => {
      console.log(error); alert(error);
    })
      .then(async (userRec) => {
        console.log("DOnneee")
        setParentemailbefore();
      })

  }

  async function deletethisnumber(value) {
    let temparray = [];
    parentphonenumber.forEach(element => {
      if (element !== value) {
        temparray.push(element);
      }
    });
    setParentphonenumber(temparray);

  }

  async function deletethisemail(value) {
    let temparray = [];
    parentemail.forEach(element => {
      if (element !== value) {
        temparray.push(element);
      }
    });
    setParentemail(temparray);

  }

  async function readonly() {
   alert("This page is 'Read Only' for Teachers.")

  }

  return (
    <div className="App-header">
 
 <div  className="section591">
 <br />  <br />
 <p className="section5922ab">Compress A Video</p>

 <br />   <br />  <br />
      <input  className="inputlength" type="file" id="fileItem" accept="video/*" onChange={handleVideoChange} />
      <br />  <br />
    
      {videoFile ? <div onClick={handleUpload}>You Selected:<br />{videoFile.name} <br /><br /></div> : null}
      {videoFile ? <div onClick={handleUpload}>Compress This Video</div> : null}
    </div>


    </div>
  );
}

export default App;

